/** @prettier */
import { isBefore } from 'date-fns';

import fetchService from '@xanadu/ui-shared/utils/fetchService';

async function useIsPreLaunch({ brand, site, domain, path, polling = false, fallbackReleaseDate }) {
  let fetching = false;
  let computedWebLaunchDate = new Date('2100-10-09T13:30:00+01:00');
  let computedAppsLaunchDate = new Date('2100-10-09T13:30:00+01:00');
  let isPreLaunch = null;
  let isAppPreLaunch = null;
  let androidStoreLink = null;
  let iosStoreLink = null;
  let isBeforeStoredLaunchDate = false;
  let preLaunchText = null;
  let underageWarning = null;
  let image = null;

  const isPreLaunchPath = path.startsWith('/pre-launch');

  // this should be a util with brand or no brand for everything or maybe not ⁻\0/⁻
  const whitelistedHostNames = [
    // 'xcl.ie',
    // `local.${domain}`,
    `beta.${domain}`,
    `internal.${domain}`,
    `beta-${brand}.xcl-portal.ie`,
    `affiliates1.${domain}`,
  ];

  const fetchingCallback = (resolve) =>
    setTimeout(() => {
      computedWebLaunchDate = fallbackReleaseDate || new Date();
      resolve();
    }, 3000);

  async function getRemoteDates() {
    fetching = true;
    await new Promise((resolve) => {
      fetchService(`/ui/api/v1/cms/content?contentType=PreLaunch&site=${site}`).then((response) => {
        const contentlets = response.contentlets;

        if (contentlets && contentlets.length) {
          const {
            webLaunchDate = '',
            appsLaunchDate = '',
            launchDateTimezone = 'GMT+0',
            preLaunchText: text,
            underageWarning: warning,
            image: preLaunchImage,
            site: configSite,
          } = contentlets[0] || {};

          if (configSite !== site) {
            resolve();
          }

          androidStoreLink = contentlets[0].androidStoreLink;
          iosStoreLink = contentlets[0].iosStoreLink;

          const webDateString = `${webLaunchDate.replace(' ', 'T').replace('.0', '')}+0${launchDateTimezone.split('+')[1]}:00`;
          const appsDateString = `${appsLaunchDate.replace(' ', 'T').replace('.0', '')}+0${launchDateTimezone.split('+')[1]}:00`;

          // Thank you Safari!
          computedWebLaunchDate = new Date(webDateString);
          computedAppsLaunchDate = new Date(appsDateString);

          preLaunchText = text;
          underageWarning = warning;
          image = preLaunchImage;

          localStorage.setItem('launch-date', webDateString);
          fetching = false;
          resolve();
        }
      });

      fetchingCallback(resolve);
    });
  }

  let devMode = false;
  let storedLaunchDate = null;
  let bypassEnabled = false;

  try {
    devMode = Boolean(localStorage.getItem('xui-dm'));
    bypassEnabled = Boolean(localStorage.getItem('prelaunch-bypass'));
    storedLaunchDate = localStorage.getItem('launch-date');
    isBeforeStoredLaunchDate = isBefore(new Date(), new Date(storedLaunchDate));

    if (!storedLaunchDate || isBeforeStoredLaunchDate || polling) {
      fetching = true;
      await getRemoteDates();
    } else {
      computedWebLaunchDate = new Date(storedLaunchDate);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error requesting pre launch config', e);
  }

  const isProduction = !whitelistedHostNames.find((w) => window.location.hostname.includes(w));
  isPreLaunch =
    isProduction && isBefore(new Date(), computedWebLaunchDate) && !devMode && !bypassEnabled;
  isAppPreLaunch =
    isProduction && isBefore(new Date(), computedAppsLaunchDate) && !devMode && !bypassEnabled;

  return {
    fetching,
    isPreLaunch,
    isAppPreLaunch,
    androidStoreLink,
    iosStoreLink,
    enablePreLaunch: isPreLaunch || (isPreLaunchPath && isBeforeStoredLaunchDate),
    preLaunchText,
    underageWarning,
    preLaunchImage: image,
  };
}

export default useIsPreLaunch;
